import React from 'react';

const FilterSidebar = ({
  filterData,
  filters,
  onFilterChange,
  onPriceChange,
  showAllBrands,
  setShowAllBrands,
  showAllVendors,
  setShowAllVendors,
  isMobile = false,
  onApply = null,
  onClose = null,
}) => (
  <div className={`filter-sidebar${isMobile ? ' filter-sidebar-mobile' : ''}`}>
    <div className="filter-sidebar-header">
      <h5 className="filter-sidebar-title">Filtra per</h5>
      {isMobile && onClose && (
        <button className="filter-sidebar-close-btn" onClick={onClose} aria-label="Chiudi filtri">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}
    </div>
    
    {/* Prezzo */}
    <div className="filter-section">
      <div className="filter-section-header">
        <h6 className="filter-section-title">Prezzo</h6>
      </div>
      <div className="filter-price-inputs">
        <div className="filter-price-pill">
          <span className="filter-price-euro">€</span>
          <input 
            type="number" 
            min={filterData.min_price} 
            max={filters.price[1]} 
            value={Number(filters.price[0]).toFixed(2)} 
            onChange={e => onPriceChange(e, 0)} 
            className="filter-price-input" 
            step="0.01" 
          />
        </div>
        <span className="filter-price-separator">-</span>
        <div className="filter-price-pill">
          <span className="filter-price-euro">€</span>
          <input 
            type="number" 
            min={filters.price[0]} 
            max={filterData.max_price} 
            value={Number(filters.price[1]).toFixed(2)} 
            onChange={e => onPriceChange(e, 1)} 
            className="filter-price-input" 
            step="0.01" 
          />
        </div>
      </div>
    </div>
    
    {/* Venditore */}
    {filterData.vendors && filterData.vendors.length > 0 && (
      <div className="filter-section">
        <div className="filter-section-header">
          <h6 className="filter-section-title">Venditore</h6>
          {filterData.vendors.length > 10 && (
            <button className="filter-show-more-btn" onClick={() => setShowAllVendors(s => !s)}>
              {showAllVendors ? 'Mostra meno' : 'Mostra tutti'}
            </button>
          )}
        </div>
        <div className="filter-checkbox-list">
          {(showAllVendors ? filterData.vendors : filterData.vendors.slice(0, 10)).map(vendor => (
            <div key={vendor} className="filter-checkbox-item">
              <input 
                className="filter-checkbox" 
                type="checkbox" 
                name="vendors" 
                value={vendor} 
                id={`vendor-${vendor}`} 
                checked={filters.vendors.includes(vendor)} 
                onChange={onFilterChange} 
              />
              <label className="filter-checkbox-label" htmlFor={`vendor-${vendor}`}>
                {vendor}
              </label>
            </div>
          ))}
        </div>
      </div>
    )}
    
    {/* Brand */}
    {filterData.brands && filterData.brands.length > 0 && (
      <div className="filter-section">
        <div className="filter-section-header">
          <h6 className="filter-section-title">Brand</h6>
          {filterData.brands.length > 10 && (
            <button className="filter-show-more-btn" onClick={() => setShowAllBrands(s => !s)}>
              {showAllBrands ? 'Mostra meno' : 'Mostra tutti'}
            </button>
          )}
        </div>
        <div className="filter-checkbox-list">
          {(showAllBrands ? filterData.brands : filterData.brands.slice(0, 10)).map(brand => (
            <div key={brand} className="filter-checkbox-item">
              <input 
                className="filter-checkbox" 
                type="checkbox" 
                name="brands" 
                value={brand} 
                id={`brand-${brand}`} 
                checked={filters.brands.includes(brand)} 
                onChange={onFilterChange} 
              />
              <label className="filter-checkbox-label" htmlFor={`brand-${brand}`}>
                {brand}
              </label>
            </div>
          ))}
        </div>
      </div>
    )}
    
    {isMobile && onApply && (
      <div className="filter-mobile-actions">
        <button className="filter-apply-btn" onClick={onApply}>
          Applica filtri
        </button>
      </div>
    )}
  </div>
);

export default FilterSidebar; 